import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as _ from "lodash";

@Injectable({
  providedIn: 'root'
})
export class CoreService {

  constructor() { }

   /**
    * Object to Http Params
    * @param obj
    * @returns
    */
  objectToHttpParams(obj: any) {
    return Object.entries(obj || {}).reduce((params, [key, value]) => {
      return params.set(
        key,
        _.isObjectLike(value) ? JSON.stringify(value) : String(value)
      );
    }, new HttpParams());
  }
}
